import styled from "styled-components";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";

type PageProps = {
  children: React.ReactNode;
  navbar?: React.ReactNode;
  centered?: boolean;
  fullHeight?: boolean;
  contentBackground?: string;
  contentOverflow?: "auto" | "hidden" | "visible";
  className?: string;
};

const PageContainer = styled.div<{ $fullHeight: boolean }>`
  ${({ $fullHeight }) =>
    $fullHeight
      ? "height: 100vh; height: 100dvh;"
      : "min-height: 100vh; min-height: 100dvh;"}
  display: flex;
  flex-direction: column;
  background-color: ${colors.backgroundDark};
  padding-top: 64px;
`;

const ContentContainer = styled.div<{ 
  $centered: boolean;
  $contentBackground?: string;
  $contentOverflow?: string;
}>`
  flex: 1;
  display: flex;
  ${({ $centered }) =>
    $centered
      ? `
    justify-content: center;
    align-items: center;
    padding: ${spacing.x4}px ${spacing.x3}px;
  `
      : ""}
  ${({ $contentBackground }) =>
    $contentBackground ? `background-color: ${$contentBackground};` : ""}
  ${({ $contentOverflow }) =>
    $contentOverflow ? `overflow-y: ${$contentOverflow};` : ""}
`;

export const Page = ({ 
  children, 
  navbar, 
  centered = false,
  fullHeight = false,
  contentBackground,
  contentOverflow,
  className 
}: PageProps) => {
  return (
    <PageContainer $fullHeight={fullHeight} className={className}>
      {navbar}
      <ContentContainer 
        $centered={centered}
        $contentBackground={contentBackground}
        $contentOverflow={contentOverflow}
      >
        {children}
      </ContentContainer>
    </PageContainer>
  );
};
